import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useTranslation } from 'react-i18next';

import useSystemOptionsStore from 'src/stores/systemOptionsStore';

interface Props {
  editionFilter: string | null;
  onEditionChange: (editionId: string | null) => void;
}

export default function MyResultsEditionFilter({ editionFilter, onEditionChange }: Props) {
  const { t } = useTranslation();
  const { editions } = useSystemOptionsStore(s => s);

  return (
    <Grid container sx={{ width: '100%' }}>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <FormControl size="small" fullWidth>
          <InputLabel id="my-results-edition-label" shrink>
            {t('editions.edition')}
          </InputLabel>
          <Select
            labelId="my-results-edition-label"
            value={editionFilter ?? ''}
            label={t('editions.edition')}
            onChange={e => onEditionChange(e.target.value || null)}
            displayEmpty
            renderValue={selected => {
              if (!selected) {
                return t('base.all');
              }
              const edition = editions?.find(ed => ed.id === selected);
              return edition ? String(edition.year) : String(selected);
            }}
          >
            <MenuItem value="">{t('base.all')}</MenuItem>
            {editions?.map(edition => (
              <MenuItem key={edition.id} value={edition.id}>
                {edition.year}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
}
